import { Injectable, Injector } from '@angular/core';
import { ArrayMenu } from './../entities/array-menu'; 
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BodyService } from '../../shared/_utils/body.service';
import { JsonApiService } from '../api/json-api.service';
import { catchError, map } from 'rxjs/operators';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import {  tap} from 'rxjs/operators';

@Injectable()
export class ArrayMenuService  extends BaseCrudService<ArrayMenu>{

    public uri = '/api/arrayMenu/';

    constructor(injector: Injector) {
      super(injector);
     //console.log('Instance ArrayMenuService');
    }
  
    buildSentence(entity?: ArrayMenu, event?: LazyLoadEvent): HttpParams {
      if (entity) {
        let query = '';
        query = query.concat(
          entity.menuCode ?
            `menuCode${QueryOperator.Contain}${entity.menuCode}${QueryOperator.Split}`
            : QueryOperator.Empty
        );
        query = query.concat(
          entity.menuName ?
            `menuName${QueryOperator.Contain}${entity.menuName}${QueryOperator.Split}`
            : QueryOperator.Empty
        );
        query = query.concat(
          entity.module ?
            `module.id${QueryOperator.Equal}${entity.module.id}${QueryOperator.Split}`
            : QueryOperator.Empty
        );
        query = query.concat(
          entity.level ?
            `level${QueryOperator.Contain}${entity.level}${QueryOperator.Split}`
            : QueryOperator.Empty
        ); 
        this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
      }
  
      if (event) {
        const page = ((event.first + event.rows) / event.rows - 1).toString();
        const size = event.rows.toString();
        this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
      }
      return this.httpParams;
    }
  
   
    searchFilters(entity?: ArrayMenu, event?: LazyLoadEvent, extraQueryCondition?: String[]): Observable<ResponsePageable<ArrayMenu>> {
  
      const url = this.rutaServidor + '/api/arrayMenu/';
      this.spinnerService.showAll();
      return this.httpClient.get<ResponsePageable<ArrayMenu>>(url, { params: this.buildSentence(entity, event) })
          .pipe(
              tap(response => {
                let contentFilter : ArrayMenu[]=[];
                  if (response.numberOfElements > 0) {
                      response.content.forEach((value) => {
                          // debugger;
                          this.addLogicToSearch(value);
                          this.convertToDate(value);
                      })
                   
                  }
                 //console.log(response);
                  this.spinnerService.hideAll();
                  return response;
              })
          );
    }

   //constructor(private httpClient: HttpClient,
   //    private bodyService: BodyService,
   //    private jsonApiService: JsonApiService,
   //    protected router: Router) { }

// OTROS SERVICIOS
 
    getTreeNodeByUser(user_id : number, arrayEntrys : any):Observable<any>{   
        const rutaServidor = localStorage.getItem('rutaServidor');
       //console.log("rutaServidor :" + rutaServidor);
        const url =  rutaServidor + '/api/arrayMenu/treeNode'; 
       //console.log("url :" + url);
    return this.httpClient.get(url+"?user_id="+user_id + "&arrayEntrys="+arrayEntrys);
}

    getTreeNodeByModule(module_id : number, arrayEntrys : any):Observable<any>{   
      const rutaServidor = localStorage.getItem('rutaServidor');
     //console.log("rutaServidor :" + rutaServidor);
      const url =  rutaServidor + '/api/arrayMenu/arrayMenuByModule'; 
     //console.log("url :" + url);
    return this.httpClient.get(url+"?module_id="+module_id + "&arrayEntrys="+arrayEntrys)
    //;
     
       .pipe(
      tap(response => { 
          if (response.numberOfElements > 0) {
              response.content.forEach((value) => {
                  // debugger;
                  this.addLogicToSearch(value);
                  this.convertToDate(value);
              })
           
          }
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
      })
  );
   
    }

    getMenuItemsSystem():Observable<any>{   
        const rutaServidor = localStorage.getItem('rutaServidor');
       //console.log("rutaServidor :" + rutaServidor);
        const url =  rutaServidor + '/api/arrayMenu/menuSistema'; 
       //console.log("url :" + url);
        return this.httpClient.get(url);
    }

    getMenuItemsByUser(user_id : number):Observable<any>{   
        const rutaServidor = localStorage.getItem('rutaServidor');
       //console.log("rutaServidor :" + rutaServidor);
        const url =  rutaServidor + '/api/arrayMenu/menuByUser'; 
       //console.log("url :" + url);
        return this.httpClient.get(url+"?user_id="+user_id);
    }

    getMenuItemsByModule(module_id : number):Observable<any>{   
      const rutaServidor = localStorage.getItem('rutaServidor');
     //console.log("rutaServidor :" + rutaServidor);
      const url =  rutaServidor + '/api/arrayMenu/menuByModule'; 
     //console.log("url :" + url);
      return this.httpClient.get(url+"?module_id="+module_id);
  } 
}



// WEBPACK FOOTER //
// ./src/app/core/services/array-menu.service.ts